import request from '../utils/request.js'

/**
 * 账户信息
 * @param params
 * @returns {AxiosPromise}
 */
export function current() {
    return request({
        url: '/api/account/current',
        method: 'get'
    })
}
/**
 * 时间统计数据 
 * @param params
 * @returns {AxiosPromise}
 */
export function getTimeData() {
    return request({
        url: '/api/count/timeData',
        method: 'get'
    })
}
/**
 * 财务管理收入统计 
 * @param params
 * @returns {AxiosPromise}
 */
export function getIncomeData() {
    return request({
        url: '/api/count/incomeData',
        method: 'get'
    })
}
/**
 * pc首页统计数据 
 * @param params
 * @returns {AxiosPromise}
 */
export function getPcCountData() {
    return request({
        url: '/api/count/pcCountData',
        method: 'get'
    })
}
/**
 * pc首页统计数据 
 * @param params
 * @returns {AxiosPromise}
 */
export function getPcHome() {
    return request({
        url: '/api/count/pc_home',
        method: 'get'
    })
}


/**
 * 银联自助签约地址
 * @param params
 * @returns {AxiosPromise}
 */
 export function unionSelfSignUrl() {
    return request({
        url: '/api/account/union_self_sign_url',
        method: 'get'
    })
}
/**
 * 同步银联自助签约
 * @param params
 * @returns {AxiosPromise}
 */
 export function syncUnionSelfSign() {
    return request({
        url: '/api/account/sync_union_self_sign',
        method: 'get'
    })
}
/**
 * 我的角色
 * @param params
 * @returns {AxiosPromise}
 */
 export function memberMy() {
    return request({
        url: '/api/shop_member/my',
        method: 'get'
    })
}

/**
 * 登录
 * @param params
 * @returns {AxiosPromise}
 */
export function login(params) {
    return request({
        url: '/api/account/login/mobile',
        method: 'post',
        data: params
    })
}
/**
 * 修改密码
 * @param params
 * @returns {AxiosPromise}
 */
export function modifyPassword(params) {
    return request({
        url: '/api/account/modify_pwd',
        method: 'post',
        data: params
    })
}

export function statement(params) {
    return request({
        url: '/api/account/statement',
        method: 'get',
        params: params
    })
}
/**
 * 查询站内信
 * @param params
 * @returns {AxiosPromise}
 */
export function inMail(params) {
    return request({
        url: '/api/in_mail',
        method: 'get',
        params: params
    })
}
/**
 * 未读站内信数量
 * @param params
 * @returns {AxiosPromise}
 */
 export function unread_count(params) {
    return request({
        url: '/api/in_mail/unread_count',
        method: 'get',
        params: params
    })
}
/**
 * 阅读站内信
 * @param params
 * @returns {AxiosPromise}
 */
 export function inMailId(id) {
    return request({
        url: `/api/in_mail/${id}`,
        method: 'get',
    })
}

/**
 * 银联提现
 * @param params
 * @returns {AxiosPromise}
 */
export function postUnionWithdraw(params) {
    return request({
        url: `/api/union_withdraw`,
        method: 'post',
        data: params
    })
}

/**
 * 银联提现记录
 * @param params
 * @returns {AxiosPromise}
 */
 export function unionWithdraw(params) {
    return request({
        url: `/api/union_withdraw`,
        method: 'get',
        params:params
    })
}

/**
 * 百米提现记录
 * @param params
 * @returns {AxiosPromise}
 */
 export function bmWithdraw(params) {
    return request({
        url: `/api/withdraw`,
        method: 'get',
        params:params
    })
}
/**
 * 菜单统计数量
 * @param params
 * @returns {AxiosPromise}
 */
export function getCount(params) {
    return request({
        url: `/api/count`,
        method: 'get',
        params:params
    })
}
/**
 * 配置:腾讯地图key
 * @param params
 * @returns {AxiosPromise}
 */
export function getTencentKey(params) {
    return request({
        url: `/api/platform/tencent_key`,
        method: 'get',
        params:params
    })
}

/**
 * 账户充值
 * @param params
 * @returns {AxiosPromise}
 */
export function paymentOrderPay(params) {
    return request({
        url: `/api/payment_order/pay`,
        method: 'post',
        data: params
    })
}
/**
 * 获取小程序太阳码
 * @param params
 * @returns {AxiosPromise}
 */
export function getQrcodeShopCode(appId,params) {
    return request({
        url: `/api/qrcode/shop_code/${appId}`,
        method: 'get',
        params:params
    })
}
/**
 * 下载海报
 * @param params
 * @returns {AxiosPromise}
 */
export function getQrcodePoster(appId,params) {
    return request({
        url: `/api/qrcode/poster/${appId}`,
        method: 'get',
        params:params
    })
}

/**
 * 平台配置V2
 * @param params
 * @returns {AxiosPromise}
 */
export function getPlatformConfigV2(params) {
    return request({
        url: `/api/platform/configV2`,
        method: 'get',
        params:params
    })
}
/**
 * 平台配置V3
 * @param params
 * @returns {AxiosPromise}
 */
export function getPlatformConfigV3(params) {
    return request({
        url: `/api/platform/configV3`,
        method: 'get',
        params:params
    })
}
/**
 * 获取碰一碰任务价格
 * @param params
 * @returns {AxiosPromise}
 */
export function getTouchItemPrice(params) {
    return request({
        url: `/api/touch/touch_item_price`,
        method: 'get',
        params:params
    })
}
/**
 * 下载
 * @param params
 * @returns {AxiosPromise}
 */
export function getDownload(params) {
    return request({
        url: `/api/download`,
        method: 'get',
        params:params
    })
}
/**
 * 视频统计
 * @param params
 * @returns {AxiosPromise}
 */
export function getGoodsVideoCount() {
    return request({
        url: `/api/goods_video/count`,
        method: 'get',
    })
}


/**
 * 获取城市
 * @param params
 * @returns {AxiosPromise}
 */
export function getCities(params) {
    return request({
        url: `/fxzb/api/platform/cities`,
        method: 'get',
        params: params
    })
}
/**
 * 搜索地理位置
 * @param params
 * @returns {AxiosPromise}
 */
export function getSearchPoi(params) {
    return request({
        url: `/fxzb/api/platform/search_poi`,
        method: 'get',
        params: params
    })
}
/**
 * 获取菜单
 * @param params
 * @returns {AxiosPromise}
 */
export function getMenus(params) {
    return request({
        url: `/api/account/menus`,
        method: 'get',
        params: params
    })
}
/**
 * 用户提现订单列表
 * @param params
 * @returns {AxiosPromise}
 */
export function get_withdraw_user_orders(params) {
    return request({
        url: `/api/withdraw/user_orders`,
        method: 'get',
        params: params
    })
}
/**
 * 确认提现
 * @param params
 * @returns {AxiosPromise}
 */
export function get_withdraw_confirm(params) {
    return request({
        url: `/api/withdraw/confirm`,
        method: 'post',
        data: params
    })
}
/**
 * 拒绝提现
 * @param params
 * @returns {AxiosPromise}
 */
export function get_withdraw_reject(params) {
    return request({
        url: `/api/withdraw/reject`,
        method: 'post',
        data: params
    })
}

/**
 * 临时令牌登录
 * @param params
 * @returns {AxiosPromise}
 */
export function post_account_login(params) {
    return request({
        url: `/api/account/login/temp`,
        method: 'post',
        params: params
    })
}
/**
 * 保存案例配置
 * @param params
 * @returns {AxiosPromise}
 */
export function post_case_config(params) {
    return request({
        url: `/api/case/config`,
        method: 'post',
        data: params
    })
}
/**
 * 保存积分商城配置
 * @param params
 * @returns {AxiosPromise}
 */
export function points_store_config(params) {
    return request({
        url: `/api/shop_keeper/points_store_config`,
        method: 'post',
        data: params
    })
}

